import { getPointsTable } from '../helpers/get-points-table';

const transpose = t => t[0].map((c, i) => t.map(r => r[i]));

const getColumn = (division, header, pointsType, index) => {
  if (index > 0) {
    return transpose(getPointsTable(division, pointsType))[index - 1]
    .reduce((table, cell) => {
      cell !== null && table.push(cell);
      return table;
    },[header]);
  };
  return [header, 0];
}; 

export const calculatePoints = (calcParams, includeFinalsPoints, includeAggregatePoints) => {
  const {
    division, 
    goRounds, 
    longRoundsPlaces, 
    finalsPlaces, 
    aggregatePlaces
  } = calcParams;

  const maxTableRows = Math.max( longRoundsPlaces, finalsPlaces, aggregatePlaces );
  const tableData = [['Places', ...Array.from({length: maxTableRows}, (x,i) => i+1)]];

  for (let i = 0; i < goRounds; i++) {
    tableData.push(getColumn(division, `Rnd ${i+1}`, 'goRound', longRoundsPlaces));
  }

  includeFinalsPoints && tableData.push(getColumn(division, 'Final Round', 'aggregated', finalsPlaces));
  includeAggregatePoints && tableData.push(getColumn(division, 'Aggregate', 'aggregated', aggregatePlaces));

  console.log(calcParams);
  console.log(transpose(tableData));
  return transpose(tableData);
};